import { useFormStore } from "../../../state/FormStore";
import { useIconStore } from "../../../state/IconStore";
import { t } from '../../../utils/i18n';

// Track which img srcs have already failed to prevent infinite onError loops
const erroredSrcs = new Set();

const ImageRadioWidget = (props) => {
    const { options, value, disabled, readonly, onChange, name } = props;
    const activeTab = useFormStore(state => state.activeTab);

    // Subscribe ONLY to iconMap — this re-renders once when the async fetch completes
    // and populates the map. Does NOT re-render during loading state transitions.
    const iconMap = useIconStore(state => state.iconMap);

    const getIconUrl = (fieldName, optionValue) => {
        const key = `${activeTab}/${fieldName}/${optionValue}`;
        if (iconMap[key]) return iconMap[key];
        // Static fallback — same convention as before
        return `icons/${activeTab}/${fieldName}-${optionValue}.png`;
    };

    return (
        <div className="darzo-customfield-imgradio">
            {options.enumOptions.map((option, index) => {
                const inputId = `img-radio-${name}-${index}-${option.value}`;
                const iconUrl = getIconUrl(name, option.value);

                return (
                    <div key={index} className="img-radio">
                        <input
                            type="radio"
                            id={inputId}
                            value={option.value}
                            checked={value === option.value}
                            onChange={(event) => onChange(event.target.value)}
                            disabled={disabled || readonly}
                            className=""
                        />
                        <label htmlFor={inputId} className="block relative cursor-pointer">
                            <img
                                src={iconUrl}
                                alt={option.label}
                                onError={(e) => {
                                    // Prevent infinite error loops
                                    if (erroredSrcs.has(e.target.src)) return;
                                    erroredSrcs.add(e.target.src);

                                    const staticPath = `icons/${activeTab}/${name}-${option.value}.png`;
                                    const currentAbsoluteSrc = e.target.src;
                                    const staticAbsolutePath = new URL(staticPath, window.location.origin).href;

                                    if (currentAbsoluteSrc !== staticAbsolutePath) {
                                        // Try static fallback if we were using a custom URL
                                        e.target.src = staticPath;
                                    }
                                    // If static also fails, browser shows broken icon — acceptable
                                }}
                                className={`${value === option.value ? '' : ''}`}
                            />
                            <span className="text-xs">{t(option.label)}</span>
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

export default ImageRadioWidget;
